import WeeklyRoutines from './week';

const PastRoutine = () => {
  return (
    <div className='text-white'>
      <WeeklyRoutines />
    </div>
  );
};

export default PastRoutine;
